import { AppContextType } from "../../../../context/AppContext"
import useAppContext from "../../../../hooks/useAppContext"
import { DateType } from "../../../../static/types/commonTypes/dateType"
import { RegistrationNoticesType } from "../../../../static/types/commonTypes/registrationNoticesType"
import DateComponent from "../../../commonComponents/DateComponent"
import RegistrationNoticesComponent from "../../../commonComponents/RegistrationNoticesComponent"

const RegistrationNotices: React.FC = () => {
    const {
        registrationDate,
        setRegistrationDate,
        registrationDateValidity,
        setRegistrationDateValidity,
        registrationDateChecked,
        setRegistrationDateChecked,

        registrationNotices, setRegistrationNotices,
        registrationNoticesValidity, setRegistrationNoticesValidity,
        registrationNoticesChecked, setRegistrationNoticesChecked,

    } = useAppContext() as AppContextType

    const updateregistrationDate = (data: Partial<DateType>) => setRegistrationDate ({...registrationDate, ...data});
    const updateRegistrationNotices = (data: Partial<RegistrationNoticesType>) => setRegistrationNotices ({...registrationNotices, ...data});

    return (
        <div className="row">
            <div className='col-sm-10'>
                <div style={{marginBottom: '-45px'}}>
                <span>
                    Renseigner ici l'enregistrement de l'acte de cession de droit au bail.
                </span>
                    <DateComponent
                        id="registrationDate"
                        date={registrationDate}
                        draftFieldName = "registrationDate"
                        changeDate={updateregistrationDate}
                        dateLabel="Date"
                        checked= {registrationDateChecked}
                        onValidationChange={(isValid: boolean) => setRegistrationDateValidity (isValid)}
                        required= {true}
                    />
                </div>
                <RegistrationNoticesComponent
                    registrationNotices= {registrationNotices}
                    checked= {registrationNoticesChecked}
                    changeRegistrationNotices={updateRegistrationNotices}
                    onValidationChange={(isValid: boolean) => setRegistrationNoticesValidity (isValid)}
                />
            </div>
        </div>
    )
 
}

export default RegistrationNotices